var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26 6a2 2 0 1 0-4 0v4a2 2 0 0 0 4 0zM12.686 9.858a2 2 0 0 0-2.826 2.828l2.828 2.828a2 2 0 0 0 2.828-2.828zm25.456 2.828a2 2 0 0 0-2.828-2.828l-2.828 2.828a2 2 0 0 0 2.828 2.828zM24 14a10 10 0 1 0 0 20 10 10 0 0 0 0-20M6 22a2 2 0 1 0 0 4h4a2 2 0 0 0 0-4zm32 0a2 2 0 0 0 0 4h4a2 2 0 0 0 0-4zM15.514 35.314a2 2 0 1 0-2.828-2.828l-2.828 2.828a2 2 0 1 0 2.828 2.828zm19.8-2.828a2 2 0 0 0-2.828 2.828l2.828 2.828a2 2 0 0 0 2.828-2.828zM26 38a2 2 0 0 0-4 0v4a2 2 0 0 0 4 0z",
    clipRule: "evenodd"
  })));
};
export default SvgSun;